import { useIsAuthenticated } from "#/hooks/useIsAuthenticated";
import { Button, Loader } from "@sicredi/react";
import styles from "./styles.module.scss";
import { useBackBlock } from "#/utils/backBlock";

type Props = {
  title?: string;
  description?: string;
};

export const NotAuthenticated: React.FC<Props> = ({
  title = "Usuário não autenticado",
  description = "Você precisa estar autenticado para acessar essa página.",
}) => {
  const { logoff } = useIsAuthenticated(false);
  const { loading } = useBackBlock();

  function handleClick() {
    window.location.href = "/";
    logoff();
  }

  return (
    <div className={styles.containerWrapper}>
      <Loader show={loading} fullScreen />
      <div className={styles.errorWrapper}>
        <div className={styles.logoWrapper}></div>
        <h1>{title}</h1>
        <p>{description}</p>
        <Button
          appearance="primary"
          type="submit"
          block={true}
          onClick={handleClick}
        >
          Retornar para a simulação
        </Button>
      </div>
    </div>
  );
};

export default NotAuthenticated;
